'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = topBarChecker;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function topBarChecker() {
  console.log('test');
  if ((0, _jquery2.default)('.cart-drawer').hasClass('expanded') && (0, _jquery2.default)('.top-bar--absolute').length) {
    var scrollTopNew = 0;
    (0, _jquery2.default)('.top-bar--absolute').addClass('display-top-bar-absolute');
    scrollTopNew = (0, _jquery2.default)(window).scrollTop();
    (0, _jquery2.default)('body').attr('data-top', (0, _jquery2.default)(window).scrollTop()).css('top', -scrollTopNew);
    (0, _jquery2.default)('html').addClass('no-scroll');
  } else {
    (0, _jquery2.default)('.top-bar--absolute').removeClass('display-top-bar-absolute');
    (0, _jquery2.default)('html').removeClass('no-scroll');
    (0, _jquery2.default)('html,body').animate({
      scrollTop: Number((0, _jquery2.default)('body').data('top'))
    }, 0);
  }
}